import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export const isValid = (user: string): boolean => {
    if (user) {
        const userData = JSON.parse(user);
        const currentTime = new Date().getTime();
        const expirationTime =  120 * 60 * 1000; // 2 hour in milliseconds

        return userData.agree_to_terms && currentTime - userData.timestamp < expirationTime ;
    }
    return false;
};
const isAuthenticated = (): boolean => {
    const user = localStorage.getItem('user');

    if (user && isValid(user)) {
        return true;
    } else {
        // If the user data is expired, remove it from localStorage
        localStorage.removeItem('user');
        return false;
    }
};
const ProtectedRoute: React.FC = () => {
    return isAuthenticated() ? <Outlet /> : <Navigate to="/" />;
};

export { ProtectedRoute, isAuthenticated };